import { React } from "react";

// project-imports
import StencilBox from "../stencils/StencilBox";
import PostYouTubeVideoStencil from "../post/PostYouTubeVideoStencil";


// third-party
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from "react-router-dom";

const HomeFourBlogStencil = ({ data, showViewAllBtn }) => {

    return (
        <div className="edu-course-area eduvibe-home-one-course course-wrapper-1 edu-section-gap bg-color-grey">
            <div className="container eduvibe-animated-shape">
                <div className="row">
                    <div className="col-lg-6">
                        <StencilBox
                            className="pre-title stencil-sm-devic mb--10"
                            width="50%"
                            height="26px"
                            backgroundColor="#F5F5F5"
                        />
                        <StencilBox
                            className="pre-title stencil-sm-devic"
                            width="90%"
                            height="56px"
                            backgroundColor="#F5F5F5"
                        />
                    </div>
                    <div className="col-lg-6">
                        <div className="load-more-btn text-end">
                            <Link className="edu-btn-stencil">
                                <StencilBox
                                    className="sf-blog-btn-stencil"
                                    width="223px"
                                    height="60px"
                                    backgroundColor="#F5F5F5"
                                />
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="row g-5 mt--10 text-center">
                    {(data || []).slice(0, 6).map((item) => (
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            className="col-12 col-sm-12 col-xl-4 col-md-6 d-flex justify-content-center"
                            animateOnce={true}
                            animatePreScroll={true}
                            key={item.id}
                        >
                            <PostYouTubeVideoStencil />
                        </ScrollAnimation>
                    ))}
                </div>
                {showViewAllBtn && (
                    <div className="row mt--60">
                        <div className="col-lg-12 d-flex justify-content-center">
                            <div className="load-more-btn text-center">
                                <StencilBox
                                    width="223.27px"
                                    height="60px"
                                    backgroundColor="#F5F5F5"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HomeFourBlogStencil;
